module.exports = __webpack_public_path__ + "static/media/29FUNOV2.d304ec94.jpg";